import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProductsHero from "@/components/products/ProductsHero";
import ProductsGrid from "@/components/products/ProductsGrid";
import CustomizationCTASection from "@/components/products/CustomizationCTASection";
import CTASection from "@/components/shared/CTASection";
import PageSEO from "@/components/shared/PageSEO";
import Breadcrumbs from "@/components/shared/Breadcrumbs";

const Products = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageSEO
        title="Electric Vehicles & Mobility Products"
        description="Browse SDC's full range of electric vehicles, patrol carts, stair climbers, unicycles and scooters in Saudi Arabia. B2B and B2G fleet solutions."
        keywords="electric vehicles Saudi Arabia, عربات كهربائية, patrol carts KSA, electric scooter Saudi, industrial EV Saudi, micro mobility products, electric unicycle KSA, stair climber Saudi Arabia"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "Electric Vehicles & Mobility Products",
          "description": "Catalog of electric vehicles, patrol carts, scooters, stair climbers and unicycles offered by SDC in Saudi Arabia.",
          "url": "https://sdcgulf.com/products",
          "mainEntity": {
            "@type": "OfferCatalog",
            "name": "SDC Mobility Catalog",
            "itemListElement": [
              { "@type": "OfferCatalog", "name": "Electric Patrol Vehicles" },
              { "@type": "OfferCatalog", "name": "Electric Scooters & Motorcycles" },
              { "@type": "OfferCatalog", "name": "Industrial Stair Climbers" },
              { "@type": "OfferCatalog", "name": "Personal Electric Unicycles" },
              { "@type": "OfferCatalog", "name": "Custom Fleet Builds" }
            ]
          }
        }}
      />
      <Navbar />
      <ProductsHero />
      <Breadcrumbs />
      <ProductsGrid />
      <CustomizationCTASection />
      <CTASection
        title="Ready to Transform Your Fleet?"
        description="Get in touch with our team to discuss your mobility needs and receive a customized quote."
        primaryButtonText="Request a Quote"
        primaryButtonLink="/contact"
        secondaryButtonText="View Services"
        secondaryButtonLink="/services"
      />
      <Footer />
    </div>
  );
};

export default Products;
